<template>
  <b-card title="Add Counter">
      <b-col cols="12">
        <b-button
          size="md"
          variant="primary"
          @click="$router.go(-1)"
          v-if="goBack !== 'other'"
          >Back</b-button
        >
      </b-col>

      <b-col cols="12">
          <label>
              Name<span style="color:red">(*)</span>
          </label>

          <b-form-input
              v-model="form.name" placeholder="Name" required :maxlength="counterMaxChar">
          </b-form-input>
      </b-col>

      <b-col cols="12">
          <label>Location<span style="color:red">(*)</span></label>
          <b-form-input disabled placeholder="Location" v-model="form.warehouse"></b-form-input>
      </b-col>

      <b-col cols="12" class="mt-2">
          <label>Salesman ID<span style="color:red">(*)</span></label>
          <b-form-input
              v-model="form.salesmanID"
              placeholder="Salesman ID"
              :maxlength="salesmanIdMaxChar"
          ></b-form-input>
      </b-col>

      <b-col cols="12" class="mt-2">
          <label>Counter can process<span style="color:red">(*)</span></label>
          <div>
            <b-form-checkbox v-model="isAll" @change="handleAllChange">ALL</b-form-checkbox>
          </div>
          <div >
            <b-form-checkbox :disabled="isAll"  v-model="ekr" @change="handleProcessChange">EKR - Online Dealer</b-form-checkbox>
            <b-form-checkbox :disabled="isAll" v-model="ekc" @change="handleProcessChange">EKC - Walk In Cash Sales</b-form-checkbox>
            <b-form-checkbox :disabled="isAll" v-model="eko" @change="handleProcessChange">EKO - Online Cash Sales</b-form-checkbox>
          </div>
      </b-col>

      <b-col v-if="permission.skip" cols="12" class="mt-2">
          <label> Manual Queue Setting </label>
          <div>
            <b-form-checkbox  v-model="form.disableSAPEkiosk">Enable Manual Queue</b-form-checkbox>
          </div>
      </b-col>
      <!-- Pay Later disabled
      <b-col cols="12" class="mt-2">
          <label> Pay Later </label>
          <div>
            <b-form-checkbox v-model="form.enablePayLater">Enable Pay Later</b-form-checkbox>
          </div>
      </b-col>
      -->

      <b-col cols="12" class="mt-2">
          <b-button variant="success" @click="submitCounter">Add</b-button>
      </b-col>
  </b-card>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { userAccess } from "@/utils/utils";

export default {
  data() {
      return {
          counterMaxChar: 15,
          salesmanIdMaxChar: 8,
          form: {
            name:"",
            warehouse:"",
            salesmanID:"",
            canProcess: ["ALL"],
            disableSAPEkiosk: false,
            enablePayLater: false
          },
          isAll: true,
          ekr: false,
          ekc: false,
          eko: false
      }
  },
  mounted() {
      // this.getCategories();
      var location = ['daikin'];
      if(!location.includes(this.$route.params.warehouse)){

      }

      this.form.warehouse=this.$route.params.warehouse
  },
  methods: {
    ...mapActions({
      addCounter: "counter/addCounter",
    }),
    handleAllChange(checked) {
      if (checked) {
        this.form.canProcess = ["ALL"];
        this.ekr = false;
        this.ekc = false;
        this.eko = false;
      } else {
        this.form.canProcess = [];
      }
    },
    handleProcessChange() {
      this.form.canProcess = [];
      if (this.ekr) this.form.canProcess.push("EKR");
      if (this.ekc) this.form.canProcess.push("EKC");
      if (this.eko) this.form.canProcess.push("EKO");
      
      // If no options selected, default to ALL
      if (this.form.canProcess.length === 0) {
        this.isAll = true;
        this.form.canProcess = ["ALL"];
      }
    },
    validateForm() {
      const salesmanID = String(this.form.salesmanID || "").trim();
      if (!salesmanID) {
        return "Salesman ID is required";
      }
      if (!/^[A-Za-z0-9]{8}$/.test(salesmanID)) {
        return "Salesman ID must be exactly 8 alphanumeric characters";
      }

      this.form.salesmanID = salesmanID;
      return "";
    },
    submitCounter() {
      const validationMessage = this.validateForm();
      if (validationMessage) {
        this.$bvToast.toast(validationMessage, {
          title: "Failed",
          variant: "danger",
          solid: true,
        });
        return;
      }

      this.addCounter(this.form).then((res) => {
        this.$bvToast.toast(`Counter added successfully`, {
          title: "Success",
          variant: "success",
          solid: true,
        })
        this.$router.go(-1);
      }).catch((err) => {
        console.error(err)
        this.$bvToast.toast(`${err.response.data.errors[0].message}`, {
          title: "Failed",
          variant: "danger",
          solid: true,
        })
      })
    }
      
  },
  computed: {
    permission() {
      let result = userAccess("Counter Daikin", "counter_menu");
      // console.log("Delivery Orders Sumitomo",result)
      return result;
    },
  }
}
</script>